import Nav from './Nav';
import { useNavigate, useLocation } from "react-router-dom";
import { toHtml, icon } from '@fortawesome/fontawesome-svg-core'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSearch } from '@fortawesome/free-solid-svg-icons'
import Login from '../components/login-sm';

function Header() {
  const location = useLocation(); // Get the current location

  // Function to check if the current path is the login page
  const isLoginPage = location.pathname === '/login';
  const navigate = useNavigate();
  function handleSubmit(e) {
    e.preventDefault();
    const form = e.target;
    console.log(form);
    const formData = new FormData(form);
    const safeFormData = formData.get("searchterm").replace(/[^a-zA-Z0-9 ]/g, '');
    navigate("/Search/" + safeFormData);
    window.location.reload();
  }
  const getSVGURI = (faIcon, color) => {
    const abstract = icon(faIcon).abstract[0];
    if (color) abstract.children[0].attributes.fill = color;
    return `data:image/svg+xml;base64,${btoa(toHtml(abstract))}`;
  }
  return (  
    <header>
    <div className="px-3 py-2"  style={{backgroundColor: '#710800'}}>
      <div className="container">
        <div className="d-flex flex-wrap align-items-center justify-content-center justify-content-lg-start">
          <Nav></Nav>
        </div>
      </div>
    </div>
    <div className="px-3 py-2 border-bottom">
      <div className="container d-flex flex-wrap justify-content-center">
        <form className="col-12 col-lg-auto mb-2 mb-lg-0 me-lg-auto" method="post" onSubmit={handleSubmit}>
          <input name="searchterm" className="search-form fa-search" type="text" placeholder='Search' style={{backgroundImage: `url(${getSVGURI(faSearch, '#710800')})`, backgroundRepeat: 'no-repeat', backgroundSize: '20px', backgroundPosition: '5px 7px'}} defaultValue=""></input>
        </form>

        <div className="text-end" style={{ display: 'none' }}>
          <button type="button" className="btn btn-light text-dark me-2">Login</button>
          <button type="button" className="btn btn-primary">Sign-up</button>
          <button type="button" className="btn btn-primary" disabled>Disabled</button>
        </div>
        
        <div className="text-end">
        {!isLoginPage && <Login />} 
        </div>

      </div>
    </div>
  </header>
  );
}

export default Header;
